import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.common_feature_card')
};
import FeatureCard from './FeatureCard.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'CommonFeatureCard',
    props: {
        feature: null
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (__props.feature === 'unlimited_teams')
                ? (_openBlock(), _createBlock(FeatureCard, {
                    key: 0,
                    image: require('@/assets/images/teams.svg'),
                    title: _ctx.$t('unlimited_teams.title'),
                    subtitle: _ctx.$t('unlimited_teams.subtitle')
                }, null, 8, ["image", "title", "subtitle"]))
                : (__props.feature === 'ice_breakers')
                    ? (_openBlock(), _createBlock(FeatureCard, {
                        key: 1,
                        image: require('@/assets/images/icebreakers.svg'),
                        title: _ctx.$t('ice_breakers.title'),
                        subtitle: _ctx.$t('ice_breakers.subtitle')
                    }, null, 8, ["image", "title", "subtitle"]))
                    : (__props.feature === 'more_activities')
                        ? (_openBlock(), _createBlock(FeatureCard, {
                            key: 2,
                            image: require('@/assets/images/activities.svg'),
                            title: _ctx.$t('more_activities.title'),
                            subtitle: _ctx.$t('more_activities.subtitle')
                        }, null, 8, ["image", "title", "subtitle"]))
                        : (__props.feature === 'slack_integration')
                            ? (_openBlock(), _createBlock(FeatureCard, {
                                key: 3,
                                image: require('@/assets/images/slack.svg'),
                                title: _ctx.$t('slack_integration.title'),
                                subtitle: _ctx.$t('slack_integration.subtitle')
                            }, null, 8, ["image", "title", "subtitle"]))
                            : _createCommentVNode("", true);
        };
    }
});
